import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Picture from 'components/picture';
import useMediaQuery from 'hooks/use-media-query';
import HeroLink from 'pages/home/hero-link';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

import HeroMaskCards from './hero-mask-cards';
import { MainHeroText } from './main-hero-text';
import { HeroContainer, HeroContent } from './styled';
import { IMainHero } from './types';

// Note: this is an existing hard-coded value for hero headings on Tims
const defaultTextColor = '#432726';

const MainHero: React.FC<IMainHero> = ({
  image,
  mobileImage,
  html,
  actionTo,
  heroTextColor,
  heroSuperText,
  heroActionText,
  heroSubText,
  heroMaskCards,
}) => {
  const { isStoreOpenAndAvailable } = useStoreContext();
  const { formatMessage } = useIntl();
  const menuHref = isStoreOpenAndAvailable ? routes.menu : routes.storeLocator;
  const isMobile = useMediaQuery('mobile');

  return (
    <>
      <Picture image={isMobile && mobileImage ? mobileImage : image} alt="">
        <HeroContent>
          <HeroContainer>
            <MainHeroText
              heroSuperText={heroSuperText}
              defaultTextColor={defaultTextColor}
              heroTextColor={heroTextColor}
              html={html}
              heroSubText={heroSubText}
            />
            <HeroLink to={actionTo || menuHref} fullWidth={isMobile}>
              <ActionButton fullWidth={isMobile}>
                {heroActionText || formatMessage({ id: 'viewMenu' })}
              </ActionButton>
            </HeroLink>
          </HeroContainer>
        </HeroContent>
      </Picture>
      {heroMaskCards && heroMaskCards.length > 0 && <HeroMaskCards cards={heroMaskCards} />}
    </>
  );
};

export default MainHero;
